import React from 'react';
import './styles.css';





export const ClaudiaAyudanteIzquierda = () => {


  return (
    <>


        <div className='ClaudiaAyudanteIzquierda-Container'>

              <div className='ClaudiaAyudanteIzquierda-maestra' />

              <div className='ClaudiaAyudanteIzquierda-nombre-texto-container'>
                  
                    <div className='ClaudiaAyudanteIzquierda-nombre' />

                    <div className='ClaudiaAyudanteIzquierda-texto'>

                        Maestra de Educación Infantil.Tutora del aula de 1-2 años y profesora de 
                        ingles en todos los niveles.
                        
                    </div>

              </div>

        </div>


    </>
  )
}
